
import { defineComponent } from "vue";
import { ref } from "vue";
import { useStore } from "vuex";
import web3Interface from "@/composables/web3Interface";
import accountManagement from "@/composables/accountManagement";
import DisplayController from "@/components/Controller/DisplayController.vue";
import { getDisplayByDisplayID, updateDisplay } from "@/api/display";
import QrScan from "@/components/Controller/QrScan.vue"

export default defineComponent({
  components: { DisplayController, QrScan },
  props: { display_id: String },
  setup(props) {
    const store = useStore();
    // set refs
    const loading_account = ref(false);
    // load composables
    const { connectWallet, setupWeb3Modal, signature, address, web3_modal } =
      web3Interface();
    const { account, tokens, loadAccount, loadTokens } = accountManagement();
    // connect to web3 wallet, and setup firebase account details
    const connectAccount = async () => {
      loading_account.value = true;
      await setupWeb3Modal();

      await connectWallet();
      // signature and account should now be set properly

      await loadAccount(address.value, signature.value);

      // add display if connected
      if (props.display_id) {
        const display = await getDisplayByDisplayID(props.display_id);
        display.entity.account_id = account.value?.id || "";
        await updateDisplay(display);
      }

      await loadTokens(address.value);

      loading_account.value = false;
    };
    connectAccount();

    //getAccountInfo(address, signature);
    return {
      connectAccount,
      account,
      web3_modal,
      signature,
      loading_account,
      tokens,
      store,
    };
  },
});
